var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5H14C15.1046 5 16 5.89543 16 7V9H10V7C10 5.89543 10.8954 5 12 5ZM9 9V7C9 5.34315 10.3431 4 12 4H14C15.6569 4 17 5.34315 17 7V9H19C20.1046 9 21 9.89543 21 11V19C21 20.1046 20.1046 21 19 21H7C5.89543 21 5 20.1046 5 19V11C5 9.89543 5.89543 9 7 9H9ZM17 10H16H10H9H7C6.44772 10 6 10.4477 6 11V19C6 19.5523 6.44772 20 7 20H19C19.5523 20 20 19.5523 20 19V11C20 10.4477 19.5523 10 19 10H17Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5H14C15.1046 5 16 5.89543 16 7V9H10V7C10 5.89543 10.8954 5 12 5ZM9 9V7C9 5.34315 10.3431 4 12 4H14C15.6569 4 17 5.34315 17 7V9H19C20.1046 9 21 9.89543 21 11V19C21 20.1046 20.1046 21 19 21H7C5.89543 21 5 20.1046 5 19V11C5 9.89543 5.89543 9 7 9H9ZM17 10H16H10H9H7C6.44772 10 6 10.4477 6 11V19C6 19.5523 6.44772 20 7 20H19C19.5523 20 20 19.5523 20 19V11C20 10.4477 19.5523 10 19 10H17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V10H17V9H16ZM10 9H9V10H10V9ZM9 9V10H10V9H9ZM17 9H16V10H17V9ZM14 4H12V6H14V4ZM17 7C17 5.34315 15.6569 4 14 4V6C14.5523 6 15 6.44772 15 7H17ZM17 9V7H15V9H17ZM16 8H10V10H16V8ZM9 7V9H11V7H9ZM12 4C10.3431 4 9 5.34315 9 7H11C11 6.44772 11.4477 6 12 6V4ZM8 7V9H10V7H8ZM12 3C9.79086 3 8 4.79086 8 7H10C10 5.89543 10.8954 5 12 5V3ZM14 3H12V5H14V3ZM18 7C18 4.79086 16.2091 3 14 3V5C15.1046 5 16 5.89543 16 7H18ZM18 9V7H16V9H18ZM19 8H17V10H19V8ZM22 11C22 9.34315 20.6569 8 19 8V10C19.5523 10 20 10.4477 20 11H22ZM22 19V11H20V19H22ZM19 22C20.6569 22 22 20.6569 22 19H20C20 19.5523 19.5523 20 19 20V22ZM7 22H19V20H7V22ZM4 19C4 20.6569 5.34315 22 7 22V20C6.44772 20 6 19.5523 6 19H4ZM4 11V19H6V11H4ZM7 8C5.34315 8 4 9.34315 4 11H6C6 10.4477 6.44772 10 7 10V8ZM9 8H7V10H9V8ZM17 9H16V11H17V9ZM16 9H10V11H16V9ZM10 9H9V11H10V9ZM9 9H7V11H9V9ZM7 9C5.89543 9 5 9.89543 5 11H7V9ZM5 11V19H7V11H5ZM5 19C5 20.1046 5.89543 21 7 21V19H5ZM7 21H19V19H7V21ZM19 21C20.1046 21 21 20.1046 21 19H19V21ZM21 19V11H19V19H21ZM21 11C21 9.89543 20.1046 9 19 9V11H21ZM19 9H17V11H19V9Z",
    fill: "black",
    mask: "url(#path-1-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/Cvc.0c0239c76c9e2ca4242e7397822f364d.svg";
export { ForwardRef as ReactComponent };